import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Cotton Candy Girl",
  description = "Gourmet cotton candy spun fresh and delivered in Boise & Meridian, Idaho. Perfect for school fundraisers, wholesale orders, events, and celebrations.",
  keywords = "gourmet cotton candy, cotton candy Boise, cotton candy Idaho, school fundraiser",
  canonical = "",
  image = "/og-image.png"
}) => {
  const siteUrl = "https://cottoncandygirl.co";
  const fullTitle = title === "Cotton Candy Girl" 
    ? "Cotton Candy Girl | Gourmet Cotton Candy Spun Fresh & Delivered" 
    : `${title} | Cotton Candy Girl`;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:secure_url" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};

export default SEO;
